var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "actions" }, [
    _c(
      "button",
      {
        staticClass: "action flip-board",
        on: {
          click: function($event) {
            _vm.$store.dispatch("flipBoard")
          }
        }
      },
      [_c("i", { staticClass: "fa fa-retweet" })]
    ),
    _c(
      "div",
      {
        staticClass: "move-actions",
        class: [{ invisible: _vm.$store.state.moves.length === 0 }]
      },
      [
        _c(
          "button",
          {
            staticClass: "action",
            on: {
              click: function($event) {
                _vm.$store.dispatch("firstMove")
              }
            }
          },
          [_vm._v("|"), _c("i", { staticClass: "fa fa-chevron-left" })]
        ),
        _c(
          "button",
          {
            staticClass: "action",
            on: {
              click: function($event) {
                _vm.$store.dispatch("prevMove")
              }
            }
          },
          [_c("i", { staticClass: "fa fa-chevron-left" })]
        ),
        _c(
          "button",
          {
            staticClass: "action",
            on: {
              click: function($event) {
                _vm.$store.dispatch("nextMove")
              }
            }
          },
          [_c("i", { staticClass: "fa fa-chevron-right" })]
        ),
        _c(
          "button",
          {
            staticClass: "action",
            on: {
              click: function($event) {
                _vm.$store.dispatch("lastMove")
              }
            }
          },
          [_c("i", { staticClass: "fa fa-chevron-right" }), _vm._v("|")]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66d056ab", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66d056ab","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/action_buttons.vue
// module id = 234
// module chunks = 0